// extracted by mini-css-extract-plugin
module.exports = {"ignore-calendar":"styles-module__ignore-calendar___oncVC"};